module.exports = __webpack_public_path__ + "static/media/the-dutch-2.71e9cae7.jpg";